import ChargeHelper from 'features/Charge/chargeHelper';
import KTFormSearch from 'general/components/OtherKeenComponents/Forms/KTFormSearch';
import KTBSDropdown from 'general/components/OtherKeenComponents/KTBSDropdown';
import AppColors from 'general/constants/AppColors';
import AppConfigs from 'general/constants/AppConfigs';
import UIHelper from 'general/helpers/UIHelper';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { useEffect, useState } from 'react';

ChargeDriverListFilterView.propTypes = {
  onCancel: PropTypes.func,
  onApply: PropTypes.func,
};

function ChargeDriverListFilterView({ onCancel, onApply, closeDropdown }) {
  // MARK: ---- PROPERTIES ----
  const [filterQ, setFilterQ] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [filterDriverType, setFilterDriverType] = useState('');
  useEffect(() => {
    setFilterQ(ChargeHelper.Filter.chargeDriverList.q);
    setFilterStatus(ChargeHelper.Filter.chargeDriverList.status);
    setFilterDriverType(ChargeHelper.Filter.chargeDriverList.driverType || '');
  }, [ChargeHelper.Filter.chargeDriverList]);

  // MARK: ---- METHODS ----
  const handleApplyFilter = () => {
    ChargeHelper.Filter.chargeDriverList = {
      ...ChargeHelper.Filter.chargeDriverList,
      status: filterStatus,
      driverType: filterDriverType,
      q: filterQ,
    };
    if (onApply) onApply();
    if (closeDropdown) closeDropdown();
  };
  const handleClearFilter = () => {
    ChargeHelper.Filter.chargeDriverList = {
      page: 0,
      limit: AppConfigs.defaultPageLimit,
      q: '',
      status: '',
      driverType: '',
    };
    if (onCancel) onCancel();
    if (closeDropdown) closeDropdown();
  };

  return (
    <div className="py-4">
      <div className="row m-0 px-2">
        {/* tim kiem */}
        <div className="col-12 mb-4 px-2">
          <KTFormSearch
            name="search_filter"
            placeholder="Theo mã khách hàng, họ và tên, số điện thoại, email, biển số xe..."
            value={filterQ}
            onSubmit={(text) => {
              setFilterQ(text);
            }}
          />
        </div>
        {/* trang thai */}
        <div className="col-12 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Trạng thái')}
          <KTBSDropdown
            name="status_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeDriverStatusOptions,
                  (item) => item.value === filterStatus
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterStatus}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeDriverStatusOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterStatus(value);
            }}
            isDropdownForm={true}
          />
        </div>
        {/* vai tro */}
        <div className="col-12 mb-4 p-0 px-2">
          {UIHelper.buildFormLabel('Vai trò')}
          <KTBSDropdown
            name="driver_type_filter"
            toggleElement={
              <button
                className="btn btn-white border-secondary dropdown-toggle w-100 d-flex align-items-center justify-content-between"
                type="button"
              >
                {_.find(
                  ChargeHelper.Data.chargeDriverTypeOptions,
                  (item) => item.value === filterDriverType
                )?.name ?? 'Tất cả'}
              </button>
            }
            selectedValue={filterDriverType}
            dropdownMenuItems={[
              { name: 'Tất cả', value: '' },
              ...ChargeHelper.Data.chargeDriverTypeOptions,
            ]}
            dropdownMenuClassName="overflow-auto w-100"
            dropdownMenuStyle={{ maxHeight: '30vh' }}
            onChange={(value) => {
              setFilterDriverType(value);
            }}
            isDropdownForm={true}
          />
        </div>
      </div>

      {/* actions */}
      <div
        className="px-4 pt-4 pb-0 d-flex align-items-center justify-content-end gap-3"
        style={{
          borderTop: `1px solid ${AppColors.gray[200]}`,
        }}
      >
        {UIHelper.buildNegativeButton('Xóa bộ lọc', handleClearFilter)}
        {UIHelper.buildGreenButton('Áp dụng', handleApplyFilter)}
      </div>
    </div>
  );
}

export default ChargeDriverListFilterView;
